export const uiStoreSlice = (set) => ({
	alertState: {
		open: false,
		message: '',
		title: '',
		errors: [],
		severity: 'info',
	},

	setAlertState: (alertState) =>
		set((state) => ({
			alertState: {
				...state.alertState,
				...alertState,
			},
		})),
});
